export const StatusContext = {
    CATEGORY_STEPS: "CATEGORY_STEPS",
    MARKET_NODE_STEPS: "MARKET_NODE_STEPS",
    LEVEL4_STEPS:"LEVEL4_STEPS"
}
export const StatusCode = {
    DATA_SUBMISSION_COMPLETED: "DATA_SUBMISSION_COMPLETED",
    MANUEL_CHECK_IN_PROGRESS: "MANUEL_CHECK_IN_PROGRESS",
    MANUAL_CHECK_COMPLETED: "MANUAL_CHECK_COMPLETED",

    PUBLISHED: "PUBLISHED",
    DRAFT: "DRAFT",
    DC_CREATION_IN_PROGRESS: "DC_CREATION_IN_PROGRESS",

    FILES_SKIPPED :"FILES_SKIPPED",

    SUBMISSION_COMPLETED_AND_PERSISTED : "SUBMISSION_COMPLETED_AND_PERSISTED",
    SUBMISSION_COMPLETED : "SUBMISSION_COMPLETED"
}
